if ($('.id-29').length || $('.id-1057').length || $('.id-7973').length) {
    getUsps('.content-wrapper');


   $(document).ready(function () {
        if (!$.fn.colorbox) return;

        $('.gallery').each(function (index) {
            $(this).find('.gallery-link').colorbox({
                rel: 'gallery-group-' + index,
                maxWidth: '95%',
                maxHeight: '95%',
                photo: true
            });
        });
    });
}


if ($('.id-29').length) {
    $(".container.breadcrumbs-wrapper").append($("h1").clone());


    $(".container.breadcrumbs-wrapper").append(`
        <div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>
      `
    );
    $(' .contactUs .left').prepend($('footer#footer .helpFooter .personLine').clone());
    $('.contactUs .right').append($('footer#footer .helpFooter .mobileCenter').clone().find('a').text(translation('vsechnyKontakty')));
    $(' .contactUs .left .text').append($('footer#footer .helpFooter .online').clone());
    //$('.cart-empty .contactUs .left').append($('footer#footer .helpFooter .online').clone());
    $(' .contactUs .left .text').append('<span class="js">' + translation('jsmeTu') + '</span>');
    $(' .contactUs .left .text').append('<span class="po">' + translation('poradit') + '</span>');
    $(" .contactUs .left .text").append("<ul></ul>");
    $(" .contactUs .left .text ul").append(
        $("footer#footer .contact-box span.tel").closest("li").clone(),
        $("footer#footer .contact-box span.mail").closest("li").clone(),
    );

    $(" .contactUs .right ").append('<h5>' + translation('stanteSeFanousky') + '</h5>');
    $(" .contactUs .right ").append('<ul class="fanList"></ul>');
    $(" .contactUs .right ul.fanList").append(
        $("footer#footer .contact-box span.facebook").closest("li").clone(),
        $("footer#footer .contact-box span.instagram").closest("li").clone(),
        $("footer#footer .contact-box span.youtube").closest("li").clone(),
        $("footer#footer .contact-box span.tiktok").closest("li").clone(),
    );

}


if ($('.id-1057').length) {
    $(".container.breadcrumbs-wrapper").append($("h1").clone());
    $(".container.breadcrumbs-wrapper").append($(".mainWrapper").clone());


    $(".content-inner").after(`
        <div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>
      `
    );
    $(' .contactUs .left').prepend($('footer#footer .helpFooter .personLine').clone());
    $('.contactUs .right').append($('footer#footer .helpFooter .mobileCenter').clone().find('a').text(translation('vsechnyKontakty')));
    $(' .contactUs .left .text').append($('footer#footer .helpFooter .online').clone());
    //$('.cart-empty .contactUs .left').append($('footer#footer .helpFooter .online').clone());
    $(' .contactUs .left .text').append('<span class="js">' + translation('jsmeTu') + '</span>');
    $(' .contactUs .left .text').append('<span class="po">' + translation('poradit') + '</span>');
    $(" .contactUs .right").append("<ul></ul>");
    $(" .contactUs .right ul").append(
        $("footer#footer .contact-box span.tel").closest("li").clone(),
        $("footer#footer .contact-box span.mail").closest("li").clone(),
    );


}




if ($('.id-7973').length) {
    $(".container.breadcrumbs-wrapper").append($("#content .top").clone());

    $(".container.breadcrumbs-wrapper .top .item.text").prepend($("h1").clone());

    $("#content .top").after(`
        <div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>
      `
    );
    $(' .contactUs .left').prepend($('footer#footer .helpFooter .personLine').clone());
    $('.contactUs .right').append($('footer#footer .helpFooter .mobileCenter').clone().find('a').text(translation('vsechnyKontakty')));
    $(' .contactUs .left .text').append($('footer#footer .helpFooter .online').clone());
    //$('.cart-empty .contactUs .left').append($('footer#footer .helpFooter .online').clone());
    $(' .contactUs .left .text').append('<span class="js">' + translation('jsmeTu') + '</span>');
    $(' .contactUs .left .text').append('<span class="po">' + translation('poradit') + '</span>');
    $(" .contactUs .right").append("<ul></ul>");
    $(" .contactUs .right ul").append(
        $("footer#footer .contact-box span.tel").closest("li").clone(),
        $("footer#footer .contact-box span.mail").closest("li").clone(),
    );


}



if ($('.id--51').length) {

    function customReviews() {
        getUsps('.content-wrapper');
        $('.content-inner').prepend($('#footer .customReviews').clone());
        $('#ratingWrapper .rate-wrap.row').append($("#ratingWrapper  .add-comment.rate-form-trigger").clone());

        $('.rate-list').each(function () {
            const $one = $(this);
            const value = parseInt($one.find('.rate-value').text().trim(), 10);
            const $stars = $one.find('.rate-star.stars');

            $stars.empty();

            for (let i = 1; i <= 5; i++) {
                if (i <= value) {
                    $stars.append('<span class="star star-on"></span>');
                } else {
                    $stars.append('<span class="star star-off"></span>');
                }
            }
        });



        $('.vote-wrap')
            .not($('.admin-response .vote-wrap'))
            .each(function () {
                const $wrap = $(this);
                const $header = $wrap.children('.vote-header').first();
                $wrap.append(
                    $header.clone().addClass('vote-header-clone')
                );
                $wrap.find('.vote-header-clone').append('<span class="verified">' + translation('overeneHodnoceni') + '</span>');

                $wrap.find('.heureka-rating-group div').each(function () {
                    const $el = $(this);
                    const cleanText = $el.text().replace(/^\s*[+-]\s*/, '');
                    $el.text(cleanText);
                })

                if ($wrap.find('.heureka-rating-group.minus').length) {
                    $wrap.find('.vote-content').each(function () {
                        const $content = $(this);
                        const nodes = this.childNodes;

                        nodes.forEach((node) => {
                            if (
                                node.nodeType === Node.TEXT_NODE &&
                                node.textContent.trim()
                            ) {
                                $(node).wrap('<div class="heureka-text"></div>');
                            }
                        });
                    });
                }
            });

    }


    customReviews();
    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        customReviews();
    });
}


if ($(".id-4070").length) {
  getUsps(".content-wrapper");

  $(".container.breadcrumbs-wrapper").append($(".topWrapper").clone());
  $(".container.breadcrumbs-wrapper .topWrapper").append($("h1").clone());

  $(".container.breadcrumbs-wrapper .topWrapper").append(`
        <div class="contactUs"><div class="left"><div class="text"></div></div></div>
      `);
  $(" .contactUs .left").prepend($("footer#footer .helpFooter .personLine").clone());
  $(" .contactUs .left").append($("footer#footer .helpFooter .online").clone());
  $(" .contactUs .left .text").append('<span class="js">' + translation("jsmeTu") + "</span>");
  $(" .contactUs .left .text").append('<span class="po">' + translation("poradit") + "</span>");
  $(" .contactUs .left .text").append("<ul></ul>");
  $(" .contactUs .left .text ul").append($("footer#footer .contact-box span.tel").closest("li").clone(), $("footer#footer .contact-box span.mail").closest("li").clone());

  $('div[itemprop="about"]').append(`
        <div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>
      `);
  $('div[itemprop="about"] .contactUs .left').prepend($("footer#footer .helpFooter .personLine").clone());
  $('div[itemprop="about"] .contactUs .right').append($("footer#footer .helpFooter .mobileCenter").clone().find("a").text(translation("vsechnyKontakty")));
  $('div[itemprop="about"] .contactUs .left .text').append($("footer#footer .helpFooter .online").clone());
  $('div[itemprop="about"] .contactUs .left .text').append('<span class="js">' + translation("jsmeTu") + "</span>");
  $('div[itemprop="about"] .contactUs .left .text').append('<span class="po">' + translation("poradit") + "</span>");
  $('div[itemprop="about"] .contactUs .right').append("<ul></ul>");
  $('div[itemprop="about"] .contactUs .right ul').append($("footer#footer .contact-box span.tel").closest("li").clone(), $("footer#footer .contact-box span.mail").closest("li").clone());
}



function getRegistrationExtraBanner() {
  const $list = $("#footer .registrationBanner:not(.registrationBanner--extra) ul").first().clone();

  const $banner = $(`
    <div class="registrationBanner registrationBanner--extra">
      <div class="h6">${translation("registraciZiskate")}</div>
      <div class="h6">${translation("uzMateUcet")}</div>
      <a href="/login/" class="btn btn-primary">${translation("prihlasitSe")}</a>
    </div>
  `);
  $banner.find(".h6").first().after($list);

  return $banner;
}

function getBenefitsOfRegistration() {
  return $("#footer .benefitsOfRegistration").first().clone();
}

if ($("body.in-registracia").length) {
  getUsps(".content-wrapper");
  $(".container.breadcrumbs-wrapper").append($("h1").clone());
  $(".container.breadcrumbs-wrapper").append($("#register-form"));

  $("#register-form").wrap('<div class="registerFormWrapper"></div>').after(getRegistrationExtraBanner());
  $("#register-form .form-group.submit-wrapper button").text(translation("registrovatSe"));
  $("#register-form .social-login h2").text(translation("neboSeRegistrujtePres"));

  $("#content-wrapper .content-inner").append(getBenefitsOfRegistration());
  $("body").addClass("customReady");
}
if ($("body.in-login").length) {
  getUsps(".content-wrapper");
  $(".container.breadcrumbs-wrapper").append($("h1").clone());
  $(".container.breadcrumbs-wrapper").append($("#formLogin"));

  $("#formLogin").wrap('<div class="registerFormWrapper"></div>').after($("#footer .registrationBanner:not(.registrationBanner--extra)").first().clone());
  $("#formLogin").prepend("<h2>" + translation("prihlaseniKVasemuUctu") + "</h2>");
  $("#content-wrapper .content-inner").append(getBenefitsOfRegistration());
  $(".social-login-buttons-divider span").text(translation("neboSePrihlastePomoci"));
  $("body").addClass("customReady");
}




if ($("body.id--24").length) {
  getUsps(".content-wrapper");

  if ($("body.type-manufacturers-listing").length) {
    $("h1").first().text("Značky").after($("#footer .znacky").clone());
    $(document).on("click", "#content .znacky .customFilter button", function () {
      const $button = $(this);
      const letter = $.trim($button.text());
      const $rows = $("#content ul.manufacturers > li");

      // opětovný klik na aktivní písmeno zobrazí zase všechny značky
      if ($button.hasClass("active")) {
        $button.removeClass("active");
        $rows.removeClass("hidden");
        return;
      }

      $button.addClass("active").siblings().removeClass("active");
      $rows.each(function () {
        $(this).toggleClass("hidden", $.trim($(this).children("h2").text()) !== letter);
      });
    });
  }
}